import { createAsyncThunk } from '@reduxjs/toolkit';
import { MyThunkApiConfig } from '../../types';

export const fetchAllDriverAction = createAsyncThunk<
  any,
  { graphqlFunction: (params: any) => Promise<any>; params: any },
  MyThunkApiConfig
>('crew/fetchAllDriverAction', async (inputData, { rejectWithValue }) => {
  const { graphqlFunction, params } = inputData;
  try {
    const response = await graphqlFunction(params);
    // TODO: here need to run filter logic based on currentBranch
    return response;
  } catch (error) {
    return rejectWithValue({ error: error.message });
  }
});

export const fetchAllHelperAction = createAsyncThunk<
  any,
  { graphqlFunction: (params: any) => Promise<any>; params: any },
  MyThunkApiConfig
>('crew/fetchAllHelperAction', async (inputData, { rejectWithValue }) => {
  const { graphqlFunction, params } = inputData;
  try {
    const response = await graphqlFunction(params);
    // TODO: here need to run filter logic based on currentBranch
    return response;
  } catch (error) {
    return rejectWithValue({ error: error.message });
  }
});

export const fetchAllTruckAction = createAsyncThunk<
  any,
  { graphqlFunction: (params: any) => Promise<any>; params: any },
  MyThunkApiConfig
>('crew/fetchAllTruckAction', async (inputData, { rejectWithValue }) => {
  const { graphqlFunction, params } = inputData;
  try {
    const response = await graphqlFunction(params);
    // TODO: here need to run filter logic based on currentBranch
    return response;
  } catch (error) {
    return rejectWithValue({ error: error.message });
  }
});
